import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://9f9bf7bd8e4882c40c392eeaec91b51a@o4509197598457856.ingest.us.sentry.io/4509197600948224"
});

import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css'
import App from './App.jsx'

import { Provider } from 'react-redux';
import { GlobalStyles } from '@bigcommerce/big-design';

import store from './redux/store';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let payload = urlParams.get('signed_payload');
let checkoutSessionId = urlParams.get('session_id');

const root = ReactDOM.createRoot(document.getElementById('root'));

if(!payload) {
  root.render(
    <React.StrictMode>
      <h1>Failed to load indentification</h1>
      <p>
        App failed to load the payload identification for this page. Please refresh the page or reload the app.
      </p>
    </React.StrictMode>
  );
}

if (payload[payload.length - 1] === '/') { 
  payload = payload.slice(0,-1);
}

if (checkoutSessionId && checkoutSessionId[checkoutSessionId.length - 1] === '/') { 
  checkoutSessionId = checkoutSessionId.slice(0,-1);
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App payload={payload} checkoutSessionId={checkoutSessionId}>
        <GlobalStyles />
      </App>
    </Provider>
  </React.StrictMode>
);